import Vue from 'vue'
import Router from 'vue-router'

import Login from "@/views/Login"
import Index from "@/views/index/Index"









import Laboratory from "./laboratory"
import Customer from "./customer"
import Excel from "./excel"


import CustomerMap from "./customerMap"
import CustomerSampleM from "./customerSampleM"
import LaboratoryMap from "./laboratoryMap"
import LaboratoryM from "./LaboratoryM"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      children:[
        Laboratory,
        Customer,
        Excel,
        CustomerMap,
        CustomerSampleM,
        LaboratoryMap,
        LaboratoryM
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js